<template>
    <div>
        <NavComponent></NavComponent>
        <SideBarComponent></SideBarComponent>
        <div class="banner" v-bind:style="{backgroundImage:'url(https://cdn.hanlandglobal.com/clean-banner.jpg)'}">

        </div>
        <div class="main content-container">
        <h3 class="app-title">日常保洁</h3>
        <p class="app-title-p"><i class="app-i app-i-left"></i>专业保洁 舒心放心<i class="app-i app-i-right"></i></p>
        <p>我们培训认证的清洁团队致力于提供最完善，最专业的清洁服务，包括以下8大项，只需确认清洁时间，无需在家看守，清洁一步到位。</p>
        <div class="main-bottom">
            <div class="main-left">
               <div><span class="bg-img left" v-bind:style="{background:'url(' + bg_img + ') no-repeat center'}" style="background-size:1.55rem 1.5rem">1</span>微信预约<img class="img-right" :src="circle_img1"/></div>
               <div><img class="img-left" :src="circle_img2"/>确认时间<span class="bg-img right" v-bind:style="{background:'url(' + bg_img2 + ') no-repeat center'}" style="background-size:1.55rem 1.5rem">2</span></div> 
               <div><span class="bg-img left" v-bind:style="{background:'url(' + bg_img + ') no-repeat center'}" style="background-size:1.55rem 1.5rem">3</span>出门玩耍<img class="img-right" :src="circle_img1"/></div>
               <div>清洁完成<span class="bg-img right" v-bind:style="{background:'url(' + bg_img2 + ') no-repeat center'}" style="background-size:1.55rem 1.5rem">4</span></div>
            </div>
            <ul>
                <li><div class="bottom-circle"><img :src="icon1" style="width:2.05rem;height:3.45rem;"/></div>除尘</li>
                <li><div class="bottom-circle"><img :src="icon2" style="width:3.05rem;height:2.8rem;"/></div>拖地</li>
                <li><div class="bottom-circle"><img :src="icon5" style="width:3.4rem;height:2.25rem;"/></div>吸尘</li>
                <li><div class="bottom-circle"><img :src="icon4" style="width:2.95rem;height:2.8rem;"/></div>抛光</li>
                <li><div class="bottom-circle"><img :src="icon6" style="width:2.4rem;height:2.4rem;"/></div>擦窗</li>
                <li><div class="bottom-circle"><img :src="icon3" style="width:1.55rem;height:2.95rem;"/></div>消毒</li>
                <li><div class="bottom-circle"><img :src="icon7" style="width:3.4rem;height:2.25rem;"/></div>卫浴</li>
                <li><div class="bottom-circle"><img :src="icon8" style="width:2.65rem;height:2.6rem;"/></div>垃圾</li>
            </ul>
        </div>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

import icon1 from '@assets/image/manage/clean-icon1.png'
import icon2 from '@assets/image/manage/clean-icon2.png'
import icon3 from '@assets/image/manage/clean-icon3.png'
import icon4 from '@assets/image/manage/clean-icon4.png'
import icon5 from '@assets/image/manage/clean-icon5.png'
import icon6 from '@assets/image/manage/clean-icon6.png'
import icon7 from '@assets/image/manage/clean-icon7.png'
import icon8 from '@assets/image/manage/clean-icon8.png'
import circle_img1 from '@assets/image/manage/circle-icon1.png'
import circle_img2 from '@assets/image/manage/circle-icon2.png'
import bg_img from '@assets/image/manage/bg-icon.png'
import bg_img2 from '@assets/image/manage/bg-icon2.png'

export default {
    name: 'CleanPage',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {
            icon1,icon2,icon3,icon4,icon5,icon6,icon7,icon8,
            circle_img1,circle_img2,bg_img,bg_img2
        }
    },
    mounted(){

    },
    methods:{

    }

}
</script>
<style lang="scss" scoped>
.banner{
    width: 100%;
    height: 20.8rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 20.8rem;  
}
.main{
    padding:5rem 0;
    text-align: center;
    color: $font;
}
.main-bottom{
    display:flex;
    justify-content: space-between;
    margin-top:2.5rem;
    .main-left{
        width: 19rem;
        color:$color;
        font-size: 1.2rem;
        font-weight: 700;
        margin-top:3rem;
        div{
            margin-bottom: 3.2rem;
            position:relative;
        }
        .bg-img{
            width: 1.5rem;
            height: 1.5rem;
            font-size: 1rem;
            letter-spacing: 2px;
            display: inline-block;
        }
        .img-right{
            position: absolute;
            top:1.5rem;
            width: 1.25rem;
            height: 3.9rem;
        }
        .img-left{
            position: absolute;
            top:1.5rem;
            left: 5.4rem;
            width: 1.35rem;
            height: 4.05rem;
        }
        .left{
            position: absolute;
            left: 4.4rem;
        }
        .right{
            position: absolute;
            right: 4.8rem;
        }
    }
    ul{
        width: 40rem;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 9rem;
            height: 9rem;
            box-shadow: 0px 5px 8px 0px 
		rgba(218, 219, 232, 0.34);
            margin:0  0 2.5rem 0.8rem;
        }
        .bottom-circle{
            width: 5.7rem;
            height: 5.7rem;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 1rem auto 0.5rem;
            background-color: #e9edf2;
            border: dashed 1px #3a4a5b;
            div{
                width: 100%;
                height: 100%;
            }
        }
    }
}
@media only screen and (max-width: 1024px){
    .banner{
        height: 18.8rem;
        background-size: cover;
    }
    .main{
        padding: 3rem 0;
    }
    .main-bottom .main-left{
        .bg-img{
            display: none;
        }
    }
}
</style>